/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		'common': {
			init: function () {
				// JavaScript to be fired on the home page

				$("#main-site-nav-toggle .navbar-toggle").on("click", function(){
					$("#main-site-slide-in-nav").addClass("open");
				});

				$("#main-site-slide-in-nav .close-btn").on("click", function(){
					$("#main-site-slide-in-nav").removeClass("open");
				});

			}
		},
		// Home page
		'home': {
			init: function () {
				// JavaScript to be fired on the home page

				if((typeof googleMapsInitialize) !== "undefined"){
					google.maps.event.addDomListener(window, "load", googleMapsInitialize);
				}

			}
		},
		'page_event_venue' : {
			init: function(){
				if((typeof googleMapsInitialize) !== "undefined"){
					google.maps.event.addDomListener(window, "load", googleMapsInitialize);
				}
			}
		},
		// Agenda page
		'page_event_agenda': {
			init: function () {
				// JavaScript to be fired on the home page

				$('.agenda-tab a[data-toggle]').on("click", function(){

					$(".agenda-tab.active").removeClass("active")

					$(this).parents(".agenda-tab").toggleClass("active");

				});

				// Keep carousel from transitioning other than on click
				$('.agenda-table-session-carousel .carousel').carousel({
					pause: true,
					interval: false
				});

				$(".agenda-table-session-carousel").on("slide.bs.carousel", function(evt){

					var carouselData = $(this).find(".carousel").data("bs.carousel");

					var currSlideNum = carouselData.getItemIndex($(this).find(evt.relatedTarget));

					$(this).find(".carousel-indicators .btn")
						.removeClass("active")
						.filter('[data-slide-to="' + currSlideNum + '"]')
							.addClass("active");

				});

			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function (func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function () {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
